import React from 'react';
import AuthLayout from '../../components/layouts/auth';
import { Link } from 'react-router-dom';
import { formatNumber, numberWithCommas, strReplace } from '../../lib/helper-support';
import LineLoader from '../../components/loader/line-loader';
import Naira from '../../components/naira';
import { useAccounts } from '../../composables/dashboard/useAccounts';

const AccountDashboard: React.FC = () => {
    const { data: accounts = [], isLoading: pageLoading, error: pageError } = useAccounts({ enabled: true });
    return (
        <AuthLayout>
            <div className='relative items-center justify-between space-y-5 md:flex md:space-y-0'>
                <div className='flex items-center space-x-5'>
                    <h1 className='page-title'>Accounts</h1>
                    <Link to='/'>View Metrics</Link>
                </div>
            </div>
            {pageLoading && <LineLoader />}
            <div className='grid gap-4 mt-10 lg:grid-cols-3 md:grid-cols-2'>
                {accounts?.map((metric: any) => (
                    <div className='p-5 bg-primary-light rounded-[13px] relative h-[10em] md:h-[12em]'>
                        <div className='flex items-center justify-between'>
                            <h4 className='font-[600] text-[13px] uppercase'>{strReplace(metric.name, '_', ' ')}</h4>
                        </div>
                        <div className='absolute top-14'>
                            <h4 className='text-blue-black font-[600] md:text-[3em] text-[2.5em]'><Naira />{formatNumber(metric.balance)}</h4>
                            <p className='text-gray-shade text-[13px] font-[600] mt-2 flex items-center'>
                                <Naira />{numberWithCommas(metric.balance)}.<span className='text-[11px]'>{numberWithCommas(metric.balance, true, true)}</span>
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </AuthLayout>
    );
}

export default AccountDashboard;